import { useT } from '@eturi/react-i18next'
import { Glyph } from '../../widgets'

type FeatureRow = {
	readonly feature: string
	readonly quickPair: boolean
}

const PairingComparisonTable = () => {
	const [t] = useT('')

	const features: FeatureRow[] = [
		{ feature: t('ourpact_features.blocks'), quickPair: true },
		{ feature: t('ourpact_features.schedules'), quickPair: true },
		{ feature: t('ourpact_features.allowance.feature'), quickPair: true },
		{ feature: t('ourpact_features.locator.feature'), quickPair: true },
		{ feature: t('ourpact_features.vew_on_demand.feature'), quickPair: true },
		{ feature: t('ourpact_features.web_filter.feature'), quickPair: false },
		{ feature: t('ourpact_features.app_rules.feature'), quickPair: false },
		{ feature: t('ourpact_features.ios_restrictions.feature'), quickPair: false },
		{ feature: t('ourpact_features.app_organizer.feature'), quickPair: false },
		{ feature: t('ourpact_features.tamper_proof.feature'), quickPair: false },
	]

	return (
		<table className="w-full max-w-105">
			<thead>
				<tr>
					<th className="text-center p-1"> </th>
					<th className="text-center p-1 text-sm">{t('actions.quick_pair')}</th>
					<th className="text-center p-1 text-sm">{t('actions.full_pair')}</th>
				</tr>
			</thead>
			<tbody>
				{features.map(({ feature, quickPair }) => (
					<tr key={feature}>
						<td className="p-1 text-sm sm:text-base">{feature}</td>
						<td className="text-center p-1">
							<Glyph
								size="xs"
								className={`${!quickPair && 'opacity-30'}`}
								name={quickPair ? 'check' : 'x'}
							/>
						</td>
						<td className="text-center p-1">
							<Glyph size="xs" name="check" />
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}

export default PairingComparisonTable
